import createSagaMiddleware from "@redux-saga/core";
import { applyMiddleware, combineReducers, compose, createStore } from "redux";

import { crashReporter, logger } from "../../../store";
import { loadingReducer } from "../reducers/loading.reducer";
import { redirectLoginReducer } from "../reducers/redirectLogin.reducer";
import { submittingLoginReducer } from "../reducers/submittingLogin.reducer";
import { submittingNewPasswordReducer } from "../reducers/submittingNewPassword.reducer";
import { submittingRecoverReducer } from "../reducers/submittingRecover.reducer";
import { submittingSignupReducer } from "../reducers/submittingSignup.reducer";
import rootSaga from "../sagas";
import { usersReducer, usersListLoading } from "../reducers/users.reducer";
import { usersPrivilegesReducer } from "../reducers/usersPrivileges.reducer";
import {
    rolesReducer,
    rolesLoading,
    shouldCloseDrawer,
    resourceEntity
} from "../reducers/roles.reducer";
import {
    subsidiaries,
    subsidiariesLoading
} from "../reducers/subsidiaries.reducer";

export const authRootReducer = combineReducers({
    loading: loadingReducer,
    submittingLogin: submittingLoginReducer,
    submittingSignup: submittingSignupReducer,
    submittingRecover: submittingRecoverReducer,
    submittingNewPassword: submittingNewPasswordReducer,
    redirectLogin: redirectLoginReducer,
    users_dict: usersReducer,
    usersListLoading,
    usersPrivileges: usersPrivilegesReducer,
    roles_dict: rolesReducer,
    rolesLoading,
    subsidiaries,
    subsidiariesLoading,
    shouldCloseDrawer,
    resourceEntity
});

const sagaMiddleware = createSagaMiddleware();

const composeEnhancers = window["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"]
    ? window["__REDUX_DEVTOOLS_EXTENSION_COMPOSE__"]({
          name: "Auth Store"
      })
    : compose;

export const authStore = createStore(
    authRootReducer,
    {},
    composeEnhancers(applyMiddleware(sagaMiddleware, logger, crashReporter))
);

export const authStoreSelectors = {
    submittingLogin: (state = authStore.getState()) => state.submittingLogin,
    submittingSignup: (state = authStore.getState()) => state.submittingSignup,
    submittingRecover: (state = authStore.getState()) =>
        state.submittingRecover,
    submittingNewPassword: (state = authStore.getState()) =>
        state.submittingNewPassword,
    redirectLogin: (state = authStore.getState()) => state.redirectLogin,
    users_dict: (state = authStore.getState()) => state.users_dict,
    usersListLoading: (state = authStore.getState()) => state.usersListLoading,
    usersPrivileges: (state = authStore.getState()) => state.usersPrivileges,
    roles_dict: (state = authStore.getState()) => state.roles_dict,
    rolesLoading: (state = authStore.getState()) => state.rolesLoading,
    shouldCloseDrawer: (state = authStore.getState()) =>
        state.shouldCloseDrawer,
    subsidiaries: (state = authStore.getState()) => state.subsidiaries,
    subsidiariesLoading: (state = authStore.getState()) =>
        state.subsidiariesLoading,
    resourceEntity: (state = authStore.getState()) => state.resourceEntity
};

sagaMiddleware.run(rootSaga);
